<template>
    <div :class="{block: showingNavigationDropdown, hidden: !showingNavigationDropdown}" class="sm:hidden">
        <div v-if="showMenu" class="pt-2 pb-3 space-y-1">
            <template v-if="$page.props?.feature_flags?.frontend">
                <!-- Public Pages -->
                <ResponsiveNavLink
                    v-if="$page.props?.feature_flags?.payments"
                    :href="route('pricing.index')"
                    :active="route().current('pricing.index')">
                    {{ $t('frontend.pricing.title') }}
                </ResponsiveNavLink>
                <ResponsiveNavLink
                    v-if="$page.props?.feature_flags?.contacts"
                    :href="route('contacts.index')"
                    :active="route().current('contacts.index')">
                    {{ $t('frontend.contact.title') }}
                </ResponsiveNavLink>
            </template>
            <template v-if="$page.props?.canLogin">
                <!-- Guest / Authenticated Pages -->
                <template v-for="(menuItem, index) in $page.props.menu" :key="index">
                    <ResponsiveNavLink
                        v-if="menuItem.show"
                        :href="menuItem.route"
                        :active="menuItem.active"
                        :as="!menuItem.inertia ? 'anchor' : null">
                        {{ menuItem.title }}
                    </ResponsiveNavLink>
                </template>
            </template>
        </div>

        <!-- Responsive User Dropdown -->
        <div v-if="$page.props?.auth?.user" class="pt-4 pb-1 border-t border-base-content/20">
            <div class="flex items-center px-4">
                <!-- User Avatar -->
                <div v-if="$page.props?.jetstream?.managesProfilePhotos" class="shrink-0 me-3">
                    <img
                        class="h-10 w-10 rounded-full object-cover"
                        :src="$page.props?.auth?.user?.profile_photo_url"
                        :alt="$page.props?.auth?.user?.name" />
                </div>
                <!-- User Name -->
                <div>
                    <div class="font-medium text-base text-base-content/80">
                        {{ $page.props?.auth?.user?.name }}
                    </div>
                    <div class="font-medium text-sm text-base-content/50">
                        {{ $page.props?.auth?.user?.email }}
                    </div>
                </div>
            </div>

            <div class="mt-3 space-y-1">
                <!-- Profile -->
                <ResponsiveNavLink :href="route('profile.show')" :active="route().current('profile.show')">
                    {{ $t('Profile') }}
                </ResponsiveNavLink>
                <!-- Billing (Customer only) -->
                <ResponsiveNavLink
                    v-if="$page.props?.feature_flags?.frontend && $page.props?.feature_flags?.payments"
                    :href="route('billing.index')"
                    as="anchor"
                    :active="route().current('billing.index')">
                    {{ $t('payments.billing.title') }}
                </ResponsiveNavLink>

                <!-- Logout -->
                <form method="POST" @submit.prevent="logout">
                    <ResponsiveNavLink as="button">{{ $t('Log Out') }}</ResponsiveNavLink>
                </form>
            </div>
        </div>
    </div>
</template>
<script setup>
import {ref} from 'vue';
import {usePage} from '@inertiajs/vue3';
import {ResponsiveNavLink} from '@/Components/Core';

const props = defineProps({
    show: {
        type: Boolean,
        required: true,
    },
});

const $page = usePage();

const showMenu = ref(
    ($page.props?.feature_flags?.frontend &&
        ($page.props?.feature_flags?.payments || $page.props?.feature_flags?.contacts)) ||
        ($page.props?.canLogin && $page.props?.menu?.length),
);

const showingNavigationDropdown = ref(props.show);

const emit = defineEmits(['switch-to-team', 'logout']);

const switchNavigationDropdown = () => {
    showingNavigationDropdown.value = !showingNavigationDropdown.value;
};

const logout = () => {
    emit('logout');
};

defineExpose({switchNavigationDropdown});
</script>
